import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../constants/routes';
import { useSession } from '../contexts/SessionContext';
import { useLanguage } from '../contexts/LanguageContext';

export default function UserProfileButton({ className = '' }) {
  const navigate = useNavigate();
  const { nurse } = useSession();
  const { t } = useLanguage();

  return (
    <button
      type="button"
      onClick={() => navigate(ROUTES.PROFILE)}
      className={`flex h-10 w-10 items-center justify-center rounded-full bg-primary-mid text-sm font-bold text-primary ${className}`}
      aria-label={t('profile')}
    >
      {nurse.initials}
    </button>
  );
}
